import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import i18n from 'i18next';

import { Typo } from 'uikit/content';
import { Tooltip } from 'uikit/tooltips';

import styles from '../styles/count.module.scss';

const Count = ({ className = '', tooltip = i18n.t('count'), value = 0, valueClassName = '' }) => (
  <Tooltip className={classnames(styles.tooltip, className)} content={tooltip}>
    <Typo className={classnames(styles.value, valueClassName)} color="secondary" variant="s01">
      {value}
    </Typo>
  </Tooltip>
);

Count.propTypes = {
  className: PropTypes.string,
  valueClassName: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.number,
};

export default React.memo(Count);
